var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "dt",
    { class: _vm.klass },
    [
      _vm._t("default"),
      _vm._v(" "),
      _vm.isRequired && !_vm.isSignup ? _c("em", [_vm._v("必須")]) : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }